import { Seo } from "@/components/Seo";
import { Reveal, HoldingsWordmark, SectionTitle } from "@/components/primitives";
import { CONTACT_DESK } from "@/lib/assets";

export default function Contact() {
  return (
    <div className="glow-black min-h-screen">
      <Seo title="Contact Us" description="Contact Jennae Michelle Holdings — mailing address, phone, and email." />
      <h1 className="sr-only">Contact Jennae Michelle Holdings</h1>

      <section className="pt-24 md:pt-28 px-6">
        <div className="max-w-5xl mx-auto">
          <Reveal>
            <div className="corner-frame overflow-hidden">
              <div className="relative aspect-[4/5] sm:aspect-[16/10]">
                <img src="/brand/contact-founder.jpg" alt="Jennae Michelle in the office before a world map" className="absolute inset-0 w-full h-full object-cover object-[center_25%]" />
                <div className="absolute inset-0 bg-gradient-to-t from-black-lux via-transparent to-transparent" />
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-16 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal><SectionTitle testid="contact-title">Some conversations need the right place to begin.</SectionTitle></Reveal>
          <Reveal delay={0.05}>
            <div className="mt-6 max-w-2xl mx-auto text-center space-y-4 text-[var(--bone)]/80 leading-relaxed">
              <p>Select the organization or type of inquiry that most closely reflects what brought you here. Your submission will be reviewed and directed to the appropriate area when possible.</p>
              <p className="text-[var(--bone)]/65 text-sm">Inquiries are handled discreetly. Submission does not establish representation, guarantee acceptance of a matter, or create an advisory relationship.</p>
            </div>
          </Reveal>

          <div className="mt-14 grid grid-cols-1 gap-8 text-center">
            <Reveal>
              <p className="font-display uppercase tracking-luxe text-xs text-[var(--gold)]">Mailing Address</p>
              <p className="mt-4 font-serif2 text-xl md:text-2xl text-[var(--bone)] leading-relaxed" data-testid="contact-address">
                Jennae Michelle Holdings, LLC<br />PO Box 29<br />Lebanon, PA 17042
              </p>
            </Reveal>
            <Reveal delay={0.06}>
              <p className="mt-6 font-serif2 text-xl md:text-2xl text-[var(--bone)]" data-testid="contact-phone">T: 717-660-6091</p>
              <a href="mailto:admin@jennaemichelle.com" className="mt-3 inline-block font-serif2 text-xl md:text-2xl gold-text link-underline" data-testid="contact-email">
                E: admin@jennaemichelle.com
              </a>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
